module.exports = __webpack_public_path__ + "static/media/tabula_colapse.e30800f2.svg";